<template>
    <div class="country-list">
        <CloseCta @click="$emit('close')"/>
        <div class="container" @wheel.stop="() => 1">
            <transition>
                <ul v-if="(!regionList.length || !countryList.length) && !specializedsubsidiaries"  class="regions blocks" key="regions">
                    <li v-for="{ name, id } in regionList" :key="id" class="region">
                        <button v-html="name" @click="$emit('region', id)" class="label"></button>
                    </li>
                    <li key="ss" class="region">
                        <button v-html="$t('common.specializedsubsidiaries')" @click="$emit('specializedsubsidiaries', true)" class="label"></button>
                    </li>
                </ul>
                <div v-else-if="(currentCountry === -1 || buListLength === 1) && !specializedsubsidiaries" class="regions" key="countries">
                    <button class="region-return-button" @click="$emit('region', -1)">
                        <IconDown class="icon-left"/>
                        <span class="label">{{ regionList[currentRegion].name }}</span>
                    </button>

                    <ul class="countries">
                        <li
                            v-for="{name, id, bu} in countryList"
                            :key="id"
                            class="country"
                        >
                            <button
                                @click="$emit('country', id)"
                                :class="['country-button', id === currentCountry && 'is-selected']"
                            >
                                <span class="label">{{name}} <span v-if="bu.length > 1">({{bu.length}})</span></span>
                                <IconDown class="icon-right" v-if="bu.length > 1"/>
                            </button>
                        </li>
                    </ul>
                </div>
                <ul v-else-if="!specializedsubsidiaries" class="regions" :key="currentCountry">
                    <button class="region-return-button" @click="$emit('close', true)">
                        <IconDown class="icon-left"/>
                        <span class="label">{{ country.name }}</span>
                    </button>

                    <ul class="countries">
                        <li
                            v-for="{name, id, country} in currentBuList"
                            :key="id"
                            class="country"
                        >
                            <button
                                @click="$emit('bu', id)"
                                :class="['country-button', id === currentBu.id && 'is-selected']"
                            >
                                <span class="label" v-html="name"></span>
                            </button>
                        </li>
                    </ul>
                </ul>
                <ul v-else class="regions" key="specializedsubsidiaries">
                    <button class="region-return-button" @click="$emit('specializedsubsidiaries', false)">
                        <IconDown class="icon-left"/>
                        <span class="label">{{$t('common.specializedsubsidiaries')}}</span>
                    </button>
                    <ul class="countries">
                        <li
                            v-for="{name, id, country} in ssList"
                            :key="id"
                            class="country"
                        >
                            <button
                                @click="$emit('bu', id)"
                                :class="['country-button', id === currentBu.id && 'is-selected']"
                            >
                                <span class="label" v-html="name"></span>
                            </button>
                        </li>
                    </ul>
                </ul>
            </transition>


        </div>
    </div>
</template>
<script>
import IconDown from '@/components/IconDown'
import CloseCta from '@/components/CloseCta'
export default {
    components: {
        IconDown,
        CloseCta
    },
    props: {
        currentCountry: {
            type: Number // -1 = no country, > -1 ID of country
        },
        regionList: {
            type: Array,
            default() { return [] }
        },
        currentRegion: {
            type: Number // -1 = no region, > -1 ID of region
        },
        specializedsubsidiaries: {
            type: Boolean
        },
        countryList: {
            type: Array,
            default() { return [] }
        },
        businesUnits: {
            type: Array,
            default() { return [] }
        },
        currentBu: {
            type: Object,
            default() { return {} }
        }
    },
    computed: {
        country() {
            return this.countryList.find(_ => _.id === this.currentCountry)
        },
        currentBuList() {
            return this.businesUnits.filter(_ => _.country === this.currentCountry).sort((a, b) => (a.name.localeCompare(b.name, 'fr')) * 2 - 1)
        },
        buListLength() {
            return this.currentBuList.length
        },
        ssList() {
            return this.businesUnits.filter(_ => _.specializedsubsidiary).sort((a, b) => (a.name.localeCompare(b.name, 'fr')) * 2 - 1)
        }
    }
}
</script>
<style lang="sass" scoped>
$returnHeight: 130px
$leftMargin: 130px
@import "@/styles/vars.sass"
.country-list
    display: flex
    flex-direction: column
    &.v-enter-active,
    &.v-leave-active
        transition: visibility .625s
        .regions
            transition: transform .625s cubic-bezier(.65,0,.25,1)
        .cross
            /deep/ .default.cross-holder
                transition: transform .625s cubic-bezier(.65,0,.25,1)
    &.v-enter
        .regions
            transform: translateX(-100%)
        .cross
            /deep/ .default.cross-holder
                transform: translateX(-100%)
    &.v-leave-to
        .regions
            transform: translateX(-100%)
        .cross
            /deep/ .default.cross-holder
                transform: translateX(-100%)
.container
    position: relative
    flex: 1
    overflow: hidden
.regions
    display: block
    position: absolute
    background: #FFFFFF
    top: 0
    left: 0
    width: 100%
    height: 100%
    overflow-y: auto
    &.blocks
        padding: 16px 60px 16px 90px
        @include media-breakpoint-down($md)
            padding: 0 9.6%

    &.v-enter-active
        transition: transform .625s cubic-bezier(.65,0,.25,1)
    &.v-leave-active
        transition: transform .625s cubic-bezier(.65,0,.25,1)
    &.v-enter
        transform: translateX(100%)
    &.v-leave-to
        transform: translateX(-100%)
    .region
        display: block
        position: relative
        margin: 0
        display: flex
        margin: 2.5em 0
        font-size: 25px
        color: #646873
        @include media-breakpoint-down($md)
            font-size: 20px
        @include media-breakpoint-down($sm)
            font-size: 17px
            margin: 9.6% 0
        .label
            flex: 1
            font-weight: 500
            text-align: left
        &:after
            content: ">"
        &:hover
            color: #ff2b2a
            cursor: pointer
.region-return-button
    padding: 0 0 0 $leftMargin
    position: relative
    height: $returnHeight
    width: 100%
    text-align: left
    border-bottom: 1px solid #d9dbde
    background-color: white
    @include media-breakpoint-down($hd)
        padding-left: 80px
    @include media-breakpoint-down($md)
        padding: 0 0 0 19.2%
        height: 65px

    .icon-left
        position: absolute
        top: 50%
        left: 0
        margin-left: 40px
        height: 9px
        width: 16px
        transform: translateY(-50%) rotate(90deg)

        @include media-breakpoint-down($md)
            margin-left: 8%
    .label
        font-size: 30px
        color: #ff2b2a
        font-weight: 500
        @include media-breakpoint-down($md)
            font-size: 25px
        @include media-breakpoint-down($sm)
            font-size: 20px
.countries
    overflow-y: scroll
    margin-top: $returnHeight
    height: calc(100% - #{$returnHeight})
    position: absolute
    top: 0
    left: 0
    width: 100%
    bottom: 0
    overflow-y: auto
    background-color: white
    @include media-breakpoint-down($md)
        margin-top: 65px
        height: auto
    .country
        margin: 50px 100px 50px $leftMargin
        display: block
        @include media-breakpoint-down($hd)
            margin-left: 80px
        @include media-breakpoint-down($md)
            margin: 5% 19.2% 5% 19.2%
        .country-button
            font-weight: 500
            cursor: pointer
            display: block
            position: relative
            height: auto
            width: 100%
            text-align: left
            color: #646873
            // padding-right: 100px
            @include media-breakpoint-down($sm)
                padding-right: 0
            .label
                font-size: 25px
                line-height: 1.5
                @include media-breakpoint-down($md)
                    font-size: 20px
                @include media-breakpoint-down($sm)
                    font-size: 17px
            .icon-right
                position: absolute
                top: 50%
                right: 0px
                transform: translateY(-50%) rotate(-90deg)
            &.is-selected
                color: #ff2b2a
            &:hover
                color: #ff2b2a
                .icon-right
                    /deep/ path
                        stroke: #ff2b2a

button
    cursor: pointer
</style>
